/**
 * 图片资产映射 —— 用 Vite import.meta.glob 把所有 PNG 注册为
 * imageKey → 哈希 URL 的查找表。对应 iOS 的 imageKey 机制。
 *
 * sync-assets 把 Assets.xcassets 的 *.imageset 扁平导出到
 * src/assets/images/<imageKey>.png；这里把它们 eager 导入。
 */

// eager + ?url 让 Vite 在构建期处理（输出带哈希的 URL）。
const modules = import.meta.glob('../assets/images/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

export const imageMap: ReadonlyMap<string, string> = (() => {
  const map = new Map<string, string>();
  for (const [path, url] of Object.entries(modules)) {
    const fileName = path.split('/').pop() ?? '';
    const imageKey = fileName.replace(/\.png$/, '');
    map.set(imageKey, url);
  }
  return map;
})();

export const imageCount = imageMap.size;

/** 按 imageKey 解析图片 URL；无对应图返回 undefined（由组件 fallback 到图标）。 */
export function resolveImage(imageKey: string): string | undefined {
  return imageMap.get(imageKey);
}
